



















import { PropType } from 'vue';
import { defineComponent, computed, toRefs } from '@vue/composition-api';
import {
  AdgroupFormData,
  CampaignFormData,
  AdgroupPeriodType,
  AdgroupConfig,
  AdgroupListItem,
  DaypartingTypeEnum,
} from '@tt4b/ttam-enums';
import Dayparting from './index';
import { isEqual } from 'lodash-es';

const name = 'ttam-dayparting-compose';

export default defineComponent({
  name,
  components: {
    TtamDaypartingSchedule: Dayparting.TtamDaypartingSchedule,
    TtamDaypartingType: Dayparting.TtamDaypartingType,
    TtamDaypartingLabel: Dayparting.TtamDaypartingLabel,
  },
  props: {
    /**
     * campaign formData
     */
    campaignData: {
      type: Object as PropType<CampaignFormData>,
      default: () => ({}),
      required: true,
    },
    /**
     * adgroup formData
     */
    adgroupData: {
      type: Object as PropType<AdgroupFormData>,
      default: () => ({}),
      required: true,
    },
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
      required: true,
    },
    cboAdgroupList: {
      type: Array as PropType<AdgroupListItem[]>,
      default: () => [],
    },
  },
  setup(props, context) {
    const { adgroupData, campaignData, adgroupConfig, cboAdgroupList } = toRefs(props);

    const _daypartingType = computed({
      get: () => props.adgroupData.period,
      set: v => {
        /**
         * period change event.
         *
         * @event type-change
         */
        context.emit('period-change', v);
      },
    });

    const _scheduleValue = computed({
      get: () => props.adgroupData.weekSchedule,
      set: v => {
        if (!isEqual(v, props.adgroupData.weekSchedule)) {
          context.emit('week-schedule-change', v);
        }
      },
    });

    const { visible } = Dayparting.usePropsVisible({
      adgroupData,
      campaignData,
    });

    return {
      name,
      visible,

      _daypartingType,
      _scheduleValue,
      options: DaypartingTypeEnum(),
      AdgroupPeriodType,
    };
  },
});
